import Layout from '@layout/Index'

export const appBanner = [
  {
    path: '/app-banner',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "app-banner-table" */ './pages/AppBannerTable.vue'),
        meta: {
          title: 'banner列表',
        },
      },
      {
        path: 'logs/:id',
        component: () => import(/* webpackChunkName: "app-banner-table" */ './pages/AppBannerLogTable.vue'),
        meta: {
          title: 'banner操作日志列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "app-banner-form" */ './pages/AppBannerForm.vue'),
        meta: {
          title: '添加banner',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "app-banner-form" */ './pages/AppBannerForm.vue'),
        meta: {
          title: '修改banner',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "app-banner-detail" */ './pages/AppBannerDetail.vue'),
        meta: {
          title: 'banner详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/app-banner/app-banner.route.js